/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable max-len */
export const catBodylanguage = [
    {
        action: 'Slow Blink',
        meaning:
            'When a cat makes eye contact and slowly closes and opens their eyes, it’s a sign of trust, comfort, and affection. In feline social behavior, this slow blink signals that they feel safe and are not threatened. Returning the gesture with your own slow blink can help strengthen your bond.',
    },
    {
        action: 'Tail Upright with a Slight Curve',
        meaning:
            'An upright tail with the tip slightly curved is a universal cat sign of confidence, friendliness, and a positive mood. This posture is often used as a greeting to people or other cats, signaling “I’m happy to see you.”',
    },
    {
        action: 'Puffed Tail',
        meaning:
            'A tail fluffed up like a bottle brush means the cat is startled, frightened, or defensive. This is part of a fight-or-flight reaction, making the cat appear larger to scare away threats. It often comes with an arched back and sideways stance.',
    },
    {
        action: 'Kneading',
        meaning:
            'Pushing the front paws in and out against a surface is a kitten behavior linked to nursing. Adult cats knead when they are content, relaxed, and feel safe, as it releases comforting memories from kittenhood.',
    },
    {
        action: 'Tail Flicking Rapidly',
        meaning:
            'A fast, repeated tail flick indicates irritation, agitation, or overstimulation. It’s a warning to stop petting or give them space before they escalate to hissing or swatting.',
    },
    {
        action: 'Belly Exposure',
        meaning:
            'Rolling over to expose the belly can be a sign of trust and comfort, as the belly is the most vulnerable area. However, it’s not always an invitation for touching — many cats will instinctively grab and kick if touched there.',
    },
    {
        action: 'Ears Flattened Back',
        meaning:
            'Pinned ears signal fear, aggression, or defensiveness. This is a pre-attack posture, warning you to back away or stop what you are doing.',
    },
    {
        action: 'Chattering at Birds or Insects',
        meaning:
            'A rapid clicking or chattering sound made when watching prey reflects a mix of excitement, frustration, and instinct. Some behaviorists believe it mimics the killing bite.',
    },
    {
        action: 'Head Bunting',
        meaning:
            'Gently bumping their head against you is a form of scent marking and affection. Cats use scent glands in their cheeks to claim you as part of their safe territory.',
    },
    {
        action: 'Purring',
        meaning:
            'A rhythmic vibrating sound usually signals comfort and happiness. However, cats may also purr when stressed, injured, or unwell, as it can help calm them and promote healing.',
    },
    {
        action: 'Arched Back with Fur Standing Up',
        meaning:
            'This posture makes the cat look bigger and is a defensive or startled reaction. It’s often accompanied by hissing, spitting, or side-stepping to face a perceived threat.',
    },
    {
        action: 'Loaf Position',
        meaning:
            'When a cat tucks all paws under their body like a bread loaf, they are comfortable but still alert. It means they are relaxed but ready to move if needed.',
    },
    {
        action: 'Sideways Hop',
        meaning:
            'A playful move often seen in kittens, where they hop sideways with an arched back. It’s a harmless way to practice hunting and fighting skills in a playful context.',
    },
    {
        action: 'Rubbing Against Your Legs',
        meaning:
            'This is both a greeting and a scent-marking action. Cats rub against you to mix their scent with yours, creating a familiar “group smell” that signals you are part of their safe circle.',
    },
    {
        action: 'Whiskers Forward',
        meaning:
            'Pushing whiskers forward indicates curiosity, interest, or hunting focus. It helps them sense the exact position of objects or prey in front of them.',
    },
    {
        action: 'Whiskers Pulled Back',
        meaning:
            'Whiskers flattened toward the face signal fear, stress, or defensiveness. This protects the whiskers during fights or from potential harm.',
    },
    {
        action: 'Sleeping with Eyes Half Open',
        meaning:
            'This is a light sleep stage where the cat rests but remains partially alert to sounds or movement. It’s common in environments where they feel safe but want to stay aware.',
    },
    {
        action: 'Twitching Ears',
        meaning:
            'Frequent ear twitches may indicate irritation, annoyance, or sensitivity to surrounding noises. It’s a sign they are paying close attention to their environment.',
    },
    {
        action: 'Dilated Pupils',
        meaning:
            'Enlarged pupils can indicate excitement, fear, hunting mode, or low light adaptation. In play, it’s usually excitement; in tense situations, it’s part of a defensive reaction.',
    },
    {
        action: 'Slow Tail Sway While Lying Down',
        meaning:
            'A gentle tail sway often means the cat is relaxed but paying attention. They may be considering whether to engage with something or stay resting.',
    },
    {
        action: 'Tail Wrapped Around Another Cat or Person',
        meaning:
            'This friendly gesture is similar to humans linking arms — it shows affection, trust, and social connection.',
    },
    {
        action: 'Sleeping Belly-Up',
        meaning:
            'A cat lying on its back with the belly exposed is showing extreme trust, as this position leaves them vulnerable. It’s one of the clearest signs they feel safe in your presence.',
    },
    {
        action: 'Hiding',
        meaning:
            'Retreating to a quiet, enclosed space can mean fear, illness, or stress. However, many cats also hide for rest and security when they want uninterrupted sleep.',
    },
    {
        action: 'Staring Without Blinking',
        meaning:
            'An unbroken stare can be a challenge or dominance display toward other animals. With humans, it may also mean intense curiosity or anticipation.',
    },
    {
        action: 'Grooming Another Cat (Allogrooming)',
        meaning:
            'Mutual grooming builds trust and strengthens social bonds between cats. It also helps maintain the group scent.',
    },
    {
        action: 'Overgrooming',
        meaning:
            'Excessive licking or chewing at fur can indicate stress, anxiety, skin irritation, parasites, or allergies. Persistent overgrooming should be checked by a vet.',
    },
    {
        action: 'Licking a Human',
        meaning:
            'Cats may lick you to show affection, mark you with their scent, or mimic social grooming behavior from their family group.',
    },
    {
        action: 'Sniffing Before Eating',
        meaning:
            'Cats rely heavily on smell to determine if food is safe, fresh, and familiar before eating.',
    },
    {
        action: 'Following You from Room to Room',
        meaning:
            'This shows attachment and interest in your activities. It’s often a sign they enjoy your company and feel bonded to you.',
    },
    {
        action: 'High-Pitched Meow',
        meaning:
            'Usually a friendly greeting or a polite request for attention, food, or interaction. It’s softer and more inviting than a loud yowl.',
    },
    {
        action: 'Loud, Repetitive Meowing',
        meaning:
            'Signals urgency, frustration, or a demand for something. It can also be a sign of loneliness or illness in older cats.',
    },
    {
        action: 'Hissing',
        meaning:
            'A defensive sound telling you to back off. It’s often accompanied by flattened ears, arched back, and bared teeth.',
    },
    {
        action: 'Growling or Yowling',
        meaning:
            'An escalated warning to stay away, often used in fights or territorial disputes. In older cats, yowling may also be linked to cognitive issues.',
    },
    {
        action: 'Sniffing Another Cat’s Rear',
        meaning:
            'A normal feline greeting where scent glands provide important identity and status information.',
    },
    {
        action: 'Nose Touch',
        meaning:
            'A gentle and brief touch of noses is a friendly greeting among cats, used to exchange scent and show peaceful intentions.',
    },
    {
        action: 'Tapping You with a Paw',
        meaning:
            'A light tap is their way of politely getting your attention for food, petting, or playtime.',
    },
    {
        action: 'Biting Gently (Love Bite)',
        meaning:
            'A soft bite during petting can be affectionate, but may also be a signal they are reaching their stimulation limit.',
    },
    {
        action: 'Biting Hard',
        meaning:
            'An aggressive bite used in self-defense or from overstimulation. Often comes after ignored warning signs.',
    },
    {
        action: 'Sitting on Your Chest or Laptop',
        meaning:
            'Shows affection, claims territory, and enjoys warmth. It can also be their way of keeping your attention focused on them.',
    },
    {
        action: 'Standing on Hind Legs',
        meaning:
            'May be curiosity-driven to get a better look, or a defensive display to appear larger.',
    },
    {
        action: 'Sniffing Your Face',
        meaning:
            'A high-trust behavior where they explore your scent closely. It’s often part of a morning greeting ritual.',
    },
    {
        action: 'Spraying Urine',
        meaning:
            'A territorial marking behavior, often triggered by stress, changes in the environment, or competition with other animals.',
    },
    {
        action: 'Scratching Furniture or Objects',
        meaning:
            'A natural behavior to sharpen claws, stretch muscles, and mark territory with both scent and visual signals.',
    },
    {
        action: 'Tail Straight Up and Quivering',
        meaning:
            'Usually a sign of excitement and greeting, though in some cases it’s associated with spraying behavior.',
    },
    {
        action: 'Ears Pointed Forward',
        meaning:
            'Shows alertness, curiosity, and interest in whatever they’re focused on.',
    },
    {
        action: 'Ears Rotating Independently',
        meaning:
            'Allows them to track sounds from multiple directions at once, an important hunting adaptation.',
    },
    {
        action: 'Yawn with Mouth Wide Open',
        meaning:
            'Often a sign of relaxation, though sometimes used as a displacement behavior to relieve mild tension.',
    },
    {
        action: 'Rubbing Cheeks on Objects',
        meaning:
            'Marks territory using scent glands in the face, creating a familiar and safe-smelling environment.',
    },
    {
        action: 'Sniffing the Air',
        meaning:
            'Tilting the head up and inhaling is a way to detect scents carried on the wind, often signaling curiosity or alertness to distant activity.',
    }
];
